var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{key:_vm.keyIndex,ref:_vm.keyIndex})])
}
var staticRenderFns = []

export { render, staticRenderFns }